<template>
  <div
    class="dropdown-form-shadow absolute -left-1/2 z-30 mt-2 w-[878px] rounded-3xl bg-white pb-4 pt-8"
  >
    <div
      v-if="isDatepickerLoading"
      class="absolute left-0 top-0 z-50 grid h-full w-full place-content-center rounded-t-3.5xl bg-white/50 backdrop-blur-sm"
    >
      <UiSpinner class="h-10 w-10 text-aui-green-400" />
    </div>
    <DatesPicker
      :slide-number="slideNumber"
      :max-slide-count="maxSlideCount"
      :selected-dates="datesPicker.selectedDates.value"
      :max-date="datesPicker.maxDate.value"
      :min-date="datesPicker.minDate.value"
      :number-of-month="datesPicker.numberOfMonth.value"
      :selected-date-field="datesPicker.selectedDateField.value"
      :available-departure-dates="datesPicker.availableDates.value"
      :available-arrival-dates="datesPicker.availableArrivalDates.value"
      @onDateChange="onDatesChange"
      @onNextSlide="nextSlide"
      @onPrevSlide="prevSlide"
    />
  </div>
</template>

<script lang="ts" setup>
  import { computed, onMounted, ref } from 'vue';
  import dayjs from 'dayjs';

  import { DatesPicker } from '@entities/dates-picker/index.desktop';
  import { UiSpinner } from '@shared/ui';
  import { useDatepicker, type SelectedDates } from '@entities/dates-picker';
  import type { DateLib } from '@shared/lib';

  const props = defineProps<{
    townFromId: number;
    countryToId: number;
    depDate?: DateLib.DateProp;
    arrDate?: DateLib.DateProp;
  }>();

  const emit = defineEmits<{
    onDatesChange: [SelectedDates[]];
  }>();

  const { flexibleDates, datesPicker, isDatepickerLoading } = useDatepicker(
    computed(() => props.countryToId),
    computed(() => props.townFromId),
  );

  const slideNumber = ref(0);
  const maxSlideCount = computed(
    () => Math.ceil(datesPicker.numberOfMonth.value / 2) - 1,
  );

  function onDatesChange(dates: DateLib.DateProp[]) {
    datesPicker.handleRangeDateChange(dates);
    emit('onDatesChange', [
      {
        from: flexibleDates.depFromDate.value,
        to: flexibleDates.depToDate.value,
      },
      {
        from: flexibleDates.arrFromDate.value,
        to: flexibleDates.arrToDate.value,
      },
    ]);
  }

  function nextSlide() {
    slideNumber.value++;
  }

  function prevSlide() {
    slideNumber.value--;
  }

  onMounted(() => {
    if (!props.depDate || !props.arrDate) {
      return;
    }
    datesPicker.handleRangeDateChange([props.depDate, props.arrDate]);

    // Set slide to active depDate
    const monthDiff = dayjs(props.depDate).diff(dayjs(), 'month');
    slideNumber.value = Math.ceil(monthDiff / 2);
  });
</script>
